"use client";

import { Accordion as AccordionLib } from "@npm_leadtech/qr-ui-components";

import { useWindowSize } from "@/hooks/browser";

import { AccordionAdapterProps } from "./types";
import { getAccordionIcon } from "@/utils/iconMap";
import "./styles.scss";

export function AccordionAdapter(props: AccordionAdapterProps) {
  const {
    title,
    subtitle,
    children,
    icon,
    defaultExpanded,
    dataQA,
    className,
    type,
    ...restProps
  } = props;

  const screenSize = useWindowSize();
  const isMobile = !!screenSize?.isMobile;

  const normalizedIcon = getAccordionIcon(icon);

  const normalizedDefaultExpanded = defaultExpanded ?? true;

  return (
    <AccordionLib
      {...restProps}
      size={isMobile ? "small" : restProps.size}
      title={title}
      subtitle={subtitle}
      type={type}
      icon={normalizedIcon}
      defaultExpanded={normalizedDefaultExpanded}
      dataQA={dataQA}
      className={className}
    >
      {children}
    </AccordionLib>
  );
}
